<script>
export default {
  props: {
    selected: { type: String, default: null },
    type: { type: String, required: true },
  },
  computed: {
    assetPath() {
      const suffix = this.selected === this.type ? '' : '-mono'
      const name = this.type + suffix
      return require('@assets/svg/' + name + '.svg')
    },
  },
}
</script>

<template>
  <div>
    <img :src="assetPath" :alt="type" />
  </div>
</template>
